/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.viewer.skins.PayPalButtonSkin'] = {
  "react": [
    [
      "form",
      "form",
      [],
      {
        "action": "https://www.paypal.com/cgi-bin/webscr",
        "method": "post"
      },
      [
        "input",
        "cmd",
        [],
        {
          "type": "hidden",
          "name": "cmd"
        }
      ],
      [
        "input",
        "item_name",
        [],
        {
          "type": "hidden",
          "name": "item_name"
        }
      ],
      [
        "input",
        "item_number",
        [],
        {
          "type": "hidden",
          "name": "item_number"
        }
      ],
      [
        "input",
        "bn",
        [],
        {
          "type": "hidden",
          "name": "bn"
        }
      ],
      [
        "input",
        "business",
        [],
        {
          "type": "hidden",
          "name": "business"
        }
      ],
      [
        "input",
        "currency_code",
        [],
        {
          "type": "hidden",
          "name": "currency_code"
        }
      ],
      [
        "input",
        "notify_url",
        [],
        {
          "type": "hidden",
          "name": "notify_url"
        }
      ],
      [
        "input",
        "return",
        [],
        {
          "type": "hidden",
          "name": "return"
        }
      ],
      [
        "input",
        "cancel_return",
        [],
        {
          "type": "hidden",
          "name": "cancel_return"
        }
      ],
      [
        "input",
        "amount",
        [],
        {
          "type": "hidden",
          "name": "amount"
        }
      ],
      [
        "img",
        "submitImage",
        [],
        {}
      ],
      [
        "img",
        "trackingPixel",
        [],
        {
          "width": "1",
          "height": "1"
        }
      ]
    ]
  ],
  "params": {
    "clr": "TEXT_COLOR"
  },
  "paramsDefaults": {
    "clr": "color_1"
  },
  "css": {
    "%": "display:table;",
    "%text": "color:[clr];position:absolute;top:48%;left:30%;",
    "%submitImage": "display:block;cursor:pointer;",
    "%trackingPixel": "position:absolute;"
  }
}

    return skins;
});
